<template>
    <div class="container">
        <template v-if="seen">
            <img class="back-img" src="../../assets/icon_fanhui@2x.png" @click="back" />
            <div class="main-title">{{ infos.title }}</div>
            <div class="time">{{ infos.createTime }}</div>
            <!-- <video class="video-box" src="https://dev.younicai.com/ync-file/ync-test/2024/06/11/20240611170823-3a039987365c494ea0fd603095c7497a.mp4" controls></video> -->
            <div class="article-wrap" :class="{ 'article-wrap--locked': shouldShowUnlock }">
                <div class="text-area ql-editor" v-html="infos.text"></div>
                <div v-if="shouldShowUnlock" class="unlock-mask" @click="handleUnlockClick">
                    <button class="unlock-card" type="button">
                        <span class="unlock-title">解锁全文</span>
                        <span class="unlock-desc">
                            收费文章 需支付
                            <span class="unlock-price">￥{{ payAmount }}</span> 解锁本文章
                        </span>
                    </button>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="title">
                <img class="back-img" src="../../assets/icon_fanhui@2x.png" @click="back" />新闻正文
            </div>
            <div class="main-title">{{ infos.title }}</div>
            <div class="time">{{ infos.createTime }}</div>
            <div class="article-wrap" :class="{ 'article-wrap--locked': shouldShowUnlock }">
                <div class="text-area ql-editor" v-html="infos.text"></div>
                <div v-if="shouldShowUnlock" class="unlock-mask" @click="handleUnlockClick">
                    <button class="unlock-card" type="button">
                        <span class="unlock-title">解锁全文</span>
                        <span class="unlock-desc">
                            收费文章 需支付
                            <span class="unlock-price">￥{{ payAmount }}</span> 解锁本文章
                        </span>
                    </button>
                </div>
            </div>
        </template>
        <el-dialog
            :visible.sync="payDialogVisible"
            :show-close="true"
            :close-on-click-modal="false"
            custom-class="pay-dialog"
            @closed="stopPayPolling"
        >
            <div class="pay-dialog-content">
                <div class="pay-dialog-title">解锁全文</div>
                <div class="pay-qr-box">
                    <img v-if="qrCodeImage" class="pay-qr" :src="qrCodeImage" alt="支付二维码" />
                    <div v-else class="pay-qr-placeholder">二维码生成中</div>
                </div>
                <div class="pay-dialog-desc">
                    收费文章 需支付 <span>￥{{ payAmount }}</span> 解锁本文章
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import QRCode from 'qrcode'
import { request } from '@/api/auth'

const USER_STORAGE_KEY = 'youcai_user'
const PAY_POLL_INTERVAL = 3000

export default {
    name: 'NewsDetailPage',
    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {
            infos: {},
            needPay: 0,
            cost: 0,
            unlocked: false,
            payDialogVisible: false,
            payCode: '',
            qrCodeImage: '',
            payPollingTimer: null,
            payCreating: false
        }
    },
    computed: {
        seen() {
            // 屏幕尺寸
            let screenWidth = document.body.clientWidth
            if (screenWidth > 768) {
                return true
            } else {
                return false
            }
        },
        shouldShowUnlock() {
            return this.isPaidArticle && !this.unlocked
        },
        isPaidArticle() {
            return Number(this.needPay) === 1
        },
        payAmount() {
            return this.cost || 0
        }
    },
    created() {
        this.getData(this.id)
    },
    beforeDestroy() {
        this.stopPayPolling()
    },
    methods: {
        getData(id) {
            request.get(`/szg-admin/common/news/getInfo/${id}`).then((response) => {
                const data = response.data || {}
                // 是否需要支付 0否 1是
                this.needPay = data.needPay || 0
                this.cost = data.cost || 0
                this.infos = data
                this.unlocked = this.paidFlag == 1
            })
        },

        back() {
            this.$router.push({ name: 'News' })
        },

        getUserInfo() {
            try {
                const rawUser = localStorage.getItem(USER_STORAGE_KEY)
                return rawUser ? JSON.parse(rawUser) : null
            } catch (error) {
                return null
            }
        },

        isLoggedIn() {
            const userInfo = this.getUserInfo()
            return Boolean(userInfo && userInfo.access_token)
        },

        handleUnlockClick() {
            if (!this.isLoggedIn()) {
                this.$router.push({
                    name: 'Login',
                    query: {
                        redirect: this.$route.fullPath
                    }
                })
                return
            }

            this.openPayDialog()
        },

        async openPayDialog() {
            if (this.payCreating) return
            this.payCreating = true

            try {
                const result = await request.get(`/system/common/news/createPay/${this.id}`)
                const data = result.data || result
                const codeUrl = data.codeUrl || ''
                this.payCode = data.payCode || ''

                if (!codeUrl || !this.payCode) {
                    this.$message.error('支付二维码获取失败')
                    return
                }

                this.qrCodeImage = await QRCode.toDataURL(codeUrl, {
                    width: 220,
                    margin: 1
                })
                this.payDialogVisible = true
                this.startPayPolling()
            } catch (error) {
                this.$message.error('支付二维码获取失败')
            } finally {
                this.payCreating = false
            }
        },

        startPayPolling() {
            this.stopPayPolling()
            this.checkPayStatus()
            this.payPollingTimer = setInterval(this.checkPayStatus, PAY_POLL_INTERVAL)
        },

        stopPayPolling() {
            if (this.payPollingTimer) {
                clearInterval(this.payPollingTimer)
                this.payPollingTimer = null
            }
        },

        async checkPayStatus() {
            if (!this.payCode) return

            const response = await request.get(
                `/system/common/news/getInfoPayStatus/${this.payCode}`
            )
            // 已支付
            if (response.data.status == '1') {
                this.stopPayPolling()
                this.payDialogVisible = false
                this.unlocked = true
                this.$message.success('已解锁收费文章，请查阅')
                this.getData(this.id)
            }
        }
    }
}
</script>

<style scoped lang="scss">
.container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .back-img {
        position: absolute;
        top: 20px;
        left: 50px;
        width: 30px;
        height: 30px;

        &:hover {
            cursor: pointer;
        }
    }

    .main-title {
        width: 70%;
        font-size: 1.875rem;
        font-weight: bold;
        margin: 60px 0 24px 0;
        text-align: center;
    }

    .time {
        font-size: 1.125rem;
        color: #666666;
        margin-bottom: 24px;
    }

    .video-box {
        width: 70%;
        height: 500px;
        margin: 10px 0;
    }

    .article-wrap {
        position: relative;
        width: 800px;
        margin: 10px 0;
    }

    .article-wrap--locked {
        max-height: 516px;
        overflow: hidden;
        margin: 0;
    }

    .text-area {
        width: 100%;
        margin: 0;
        color: #333333;
        font-size: 1rem;
        line-height: 2;
        word-break: break-word;

        ::v-deep p {
            margin: 0 0 16px;
        }

        ::v-deep p:last-child {
            margin-bottom: 0;
        }

        ::v-deep img {
            max-width: 100%;
        }

        ::v-deep video {
            max-width: 100%;
        }
    }

    .article-wrap--locked .text-area {
        min-height: 220px;
        padding-bottom: 190px;
        box-sizing: border-box;
    }

    .unlock-mask {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        height: 180px;
        align-items: flex-end;
        justify-content: center;
        padding-bottom: 34px;
        box-sizing: border-box;
        background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(232, 250, 240, 0.92) 38%,
            #15803c 100%
        );
        cursor: pointer;
    }

    .unlock-card {
        display: flex;
        width: 300px;
        height: 96px;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        border: 1px solid rgba(21, 128, 60, 0.18);
        border-radius: 4px;
        background: #ffffff;
        color: #222222;
        cursor: pointer;
        box-shadow: 0 12px 28px rgba(21, 128, 60, 0.14);
    }

    .unlock-title {
        color: #15803c;
        font-size: 1.25rem;
        font-weight: bold;
        line-height: 28px;
    }

    .unlock-desc {
        margin-top: 18px;
        font-size: 0.875rem;
        line-height: 20px;
    }

    .unlock-price {
        color: #ff405c;
        font-size: 1rem;
    }

    ::v-deep .pay-dialog {
        width: 440px;
        border-radius: 6px;
    }

    ::v-deep .pay-dialog .el-dialog__header {
        padding: 0;
    }

    ::v-deep .pay-dialog .el-dialog__body {
        padding: 34px 40px 42px;
    }

    .pay-dialog-content {
        text-align: center;
    }

    .pay-dialog-title {
        color: #333333;
        font-size: 1.5rem;
        font-weight: bold;
        line-height: 34px;
    }

    .pay-qr-box {
        display: flex;
        width: 220px;
        height: 220px;
        align-items: center;
        justify-content: center;
        margin: 24px auto;
    }

    .pay-qr {
        display: block;
        width: 220px;
        height: 220px;
    }

    .pay-qr-placeholder {
        color: #999999;
        font-size: 0.875rem;
    }

    .pay-dialog-desc {
        color: #222222;
        font-size: 1.125rem;
        line-height: 26px;
    }

    .pay-dialog-desc span {
        color: #ff405c;
        font-size: 1.25rem;
    }

    ::v-deep ol {
        list-style: decimal !important;
        padding-left: 50px;
    }

    ::v-deep ul {
        list-style: disc !important;
        padding-left: 50px;
    }

    @media screen and (max-device-width: 768px) {
        .title {
            width: 100%;
            height: 40px;
            line-height: 40px;
            position: relative;
            text-align: center;
            font-weight: bold;
            font-size: 1.125rem;
            margin-top: 13px;
            .back-img {
                position: absolute;
                left: 16px;
                top: 12px;
                width: 18px;
                height: 18px;
            }
        }
        .main-title {
            width: calc(100% - 30px);
            text-align: center;
            font-size: 1.25rem;
            line-height: 1.875rem;
            font-weight: 500;
            margin: 10px 0;
            padding: 0 15px;
        }
        .time {
            font-size: 0.875rem;
            color: #666666;
            margin-bottom: 24px;
            width: calc(100% - 15px);
            padding-left: 15px;
        }
        .video-box {
            width: 90%;
            height: 200px;
        }
        .article-wrap {
            width: 90%;
        }
        .article-wrap--locked {
            width: 100%;
            max-height: 580px;
        }
        .text-area {
            font-size: 0.875rem;
            line-height: 1.9;
        }
        .article-wrap--locked .text-area {
            width: 90%;
            margin: 0 auto;
            min-height: 230px;
            padding-bottom: 200px;
        }
        .unlock-mask {
            height: 184px;
            padding: 0 18px 22px;
        }
        .unlock-card {
            width: 100%;
            height: 112px;
        }
        .unlock-title {
            font-size: 1.375rem;
            line-height: 30px;
        }
        .unlock-desc {
            margin-top: 20px;
            font-size: 1rem;
        }
        ::v-deep .pay-dialog {
            width: calc(100% - 32px);
        }
        ::v-deep .pay-dialog .el-dialog__body {
            padding: 30px 18px 36px;
        }
        .pay-dialog-title {
            font-size: 1.375rem;
        }
        .pay-qr-box,
        .pay-qr {
            width: 190px;
            height: 190px;
        }
        .pay-dialog-desc {
            font-size: 1rem;
        }
    }

    @media screen and (min-device-width: 769px) and (max-device-width: 1100px) {
        .video-box {
            width: 80%;
            height: 400px;
        }
        .article-wrap {
            width: 600px;
        }
    }
}
</style>
